<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          View Rule
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="view-rules">
          <span><b>Name: &nbsp;</b></span>
          <span class="name">{{ formData.name }}</span>
        </div>
        <div v-if="formData.rule_json">
          <ul class="tree-list">
            <view-tree :node="formData.rule_json"></view-tree>
          </ul>
        </div>
        <div v-if="formData.tags && formData.tags != 'NA'" class="tags">
          <div
            v-for="(value, key) in splitJoin(formData.tags)"
            :key="key"
            class="tag is-primary"
          >
            <span>{{ value }}</span>
          </div>
        </div>
        <div
          v-if="formData.action_function && formData.action_value"
          class="view-rules"
        >
          <span><b>Action function: &nbsp;</b></span>
          <span class="name">{{ formData.action_function }}</span>
          <span> &nbsp;</span>
          <span class="name">{{ formData.action_value }}%</span>
          <span class="name">{{ formData.reporting_category }}%</span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="confirm"
          v-if="showEditButton"
        >
          Edit
        </b-button>
        <b-button slot="right" class="is-normal" @click="cancel">
          Back
        </b-button>
        <span v-on:click="checkReportDef" slot="right"
          ><a href="#">Check Report Definitions</a></span
        >
      </footer>
    </div>
  </b-modal>
</template>

<script>
// @group General
import ViewTree from "@/components/RulesManager/ViewTree.vue";
export default {
  name: "ViewRules",
  components: { ViewTree },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: null
    },
    showEditButton: {
      type: Boolean,
      default: true
    },
    ruleTags: []
  },
  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    splitJoin(theText) {
      return theText.split(",");
    },
    checkReportDef() {
      this.$emit("checkReportDef");
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm", this.formData);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
